import React from 'react';
import { Box, IconButton, HStack } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { FiX } from 'react-icons/fi';
import { trackingService } from '../../../../shared/eventTracking';

interface HeaderProps {
  isRecording: boolean;
  setIsMinimized: (minimized: boolean) => void;
  setInternalIsOpen: (open: boolean) => void;
  showTimeLimitReached: boolean;
  closeTimeLimitScreen: () => void;
  handleClose: () => void;
}

function Header({
  isRecording,
  setIsMinimized,
  setInternalIsOpen,
  showTimeLimitReached,
  closeTimeLimitScreen,
  handleClose,
}: HeaderProps) {
  return (
    <Box p="16px" position="relative">
      <HStack justify="flex-end" spacing="8px">
        {/* Botão minimizar */}
        <IconButton
          aria-label="Minimizar"
          icon={<ChevronDownIcon boxSize="16px" />}
          size="xs"
          variant="ghost"
          bg="#FFB3D1"
          color="purple.600"
          borderRadius="50%"
          _hover={{ bg: '#FF9DC4' }}
          onClick={() => {
            if (isRecording) {
              trackingService.trackPrescriptionVoiceWindowToggle('minimize');
              setIsMinimized(true);
            } else {
              setInternalIsOpen(false);
            }
          }}
        />
        {/* Botão fechar */}
        <IconButton
          aria-label="Fechar"
          icon={<FiX size="16px" />}
          size="xs"
          variant="ghost"
          bg="transparent"
          color="#B4A7D6"
          borderRadius="50%"
          border="2px solid"
          borderColor="#B4A7D6"
          _hover={{ bg: 'purple.50' }}
          onClick={showTimeLimitReached ? closeTimeLimitScreen : handleClose}
        />
      </HStack>
    </Box>
  );
}

export { Header };
